<div style="display: block">
  <canvas baseChart [datasets]="chartData" [labels]="chartLabels" [options]="chartOptions" [legend]="chartLegend"
    [type]="chartType">
  </canvas>
</div>
